// extracted by mini-css-extract-plugin
module.exports = {"content":"Global_content__ARtKg","testCSS":"Global_testCSS__3ULLK"};